import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { escapeRegExp } from '@jpmuitk/utils';
import { withStyles } from '@jpmuitk/theme';
export var styles = function styles(theme) {
  var typography = theme.toolkit.typography;
  return {
    highlight: typography.getFace('bold')
  };
};

var Highlighter = function Highlighter(props) {
  var classes = props.classes,
      className = props.className,
      matchPattern = props.matchPattern,
      _props$text = props.text,
      text = _props$text === void 0 ? '' : _props$text;

  if (matchPattern == null) {
    return text;
  }

  var matchRegex = typeof matchPattern === 'string' ? new RegExp("(".concat(escapeRegExp(matchPattern), ")"), 'gi') : matchPattern;
  return /*#__PURE__*/React.createElement(React.Fragment, null, text.split(matchRegex).map(function (part, index) {
    return part.match(matchRegex) ? /*#__PURE__*/React.createElement("strong", {
      className: classnames(classes.highlight, className),
      key: "".concat(index, "-").concat(part)
    }, part) : part;
  }));
};

process.env.NODE_ENV !== "production" ? Highlighter.propTypes = {
  /**
   * The className(s) of the component.
   */
  className: PropTypes.string,

  /**
   * Useful to extend the style applied to components.
   */
  classes: PropTypes.objectOf(PropTypes.string),

  /**
   * The pattern to match. It can be a simple string match.
   */
  matchPattern: PropTypes.oneOfType([PropTypes.instanceOf(RegExp), PropTypes.string]),

  /**
   * The full text to be displayed.
   */
  text: PropTypes.string
} : void 0;
export default withStyles(styles, {
  name: 'Highlighter'
})(Highlighter);